import {gql, useMutation} from '@apollo/client';
import type {MutationHookOptions} from '@apollo/client';
import type {
  CompleteReviewMutation,
  CompleteReviewMutationVariables,
} from '../types/graphql';

/**
 * Mutation to complete a review.
 */
export const COMPLETE_REVIEW = gql`
  mutation CompleteReview($reviewQueueEntryId: ID!) {
    completeReview(reviewQueueEntryId: $reviewQueueEntryId) {
      id
      lastReviewerAccountId
      lastReviewTs
    }
  }
`;

/**
 * Hook to complete a review.
 */
export const useCompleteReview = (
  opts?: MutationHookOptions<
    CompleteReviewMutation,
    CompleteReviewMutationVariables
  >,
) =>
  useMutation<CompleteReviewMutation, CompleteReviewMutationVariables>(
    COMPLETE_REVIEW,
    opts,
  );
